import React from 'react';
import { Register } from '../factory';
import { Icon, List, Modal, SearchBar } from 'antd-mobile';

@Register({ name: 'dy-select' })
class DySelect extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            searchValue: '',
        };
    }
    handleSearchChange = val => {
        this.setState({
            searchValue: val,
        });
    };

    handleSelectItem = sel => {
        this.setState({
            visible: false,
            searchValue: '',
        })
        this.props.onChange?.(sel);
    };

    render() {
        let { className, name, options, value } = this.props;
        const { searchValue, visible } = this.state;
        if (!options) {
            return '';
        }
        const currentValue = options.find(item => Number(item.seq) === value);
        const currentOptions = options.filter(op => op.content.includes(searchValue));
        
        return (
            <div className={`dy-fm-item dy-fm-item-select ${className ? className : ''}`}>
                <div 
                    className={`dy-fm-item-pick-view ${value ? 'edited' : ''}`} 
                    onClick={() => this.setState({visible: true})}
                >
                    {value ? currentValue?.content : '请选择'}
                </div>
                <Modal 
                    popup
                    title={'请选择'}
                    visible={visible}
                    onClose={() => this.setState({visible: false})}
                    animationType="slide-up"
                    className="slide-search dy-fm-item-select-search"
                >
                    <SearchBar
                        value={searchValue}
                        placeholder="输入关键字搜索"
                        onChange={this.handleSearchChange}
                        onCancel={() => this.setState({visible: false})}
                    />
                    <List className="slide-search-list">
                        {(currentOptions || []).map((item, index) => (
                            <List.Item
                                key={index}
                                className={`slide-search-item ${Number(item.seq) == value ? 'selected' : ''}`}
                                extra={Number(item.seq) == value ? <Icon type="check" /> : ''}
                                onClick={() => this.handleSelectItem(Number(item.seq))}
                            >
                                {item.content}
                            </List.Item>
                        ))}
                    </List>
                </Modal>
            </div>
        );
    }
}

export default DySelect;
